import { isElementInViewport } from '@theme/utilities';

// Atelier Nacre : la barre apparaît dès qu'on a un peu défilé et que le bouton d'origine
// n'est pas visible à l'écran ; elle s'efface quand le bouton d'origine revient ou près du pied de page.
class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.footer = null;
    this.ph = null;
    this.onScroll = this.update.bind(this);
  }

  connectedCallback() {
    this.footer = document.querySelector('[data-ref="footer"]');
    this.ph = document.createElement('div');
    this.ph.className = 'an-sticky-ph';
    this.parentNode.insertBefore(this.ph, this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (this.ph) this.ph.remove();
  }

  headerBottom() {
    let b = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach((h) => {
      const p = getComputedStyle(h).position;
      if (p === 'sticky' || p === 'fixed') b = Math.max(b, h.getBoundingClientRect().bottom);
    });
    return b;
  }

  update() {
    const active = this.dataset.active === 'true';
    const r = active ? this.ph.getBoundingClientRect() : this.getBoundingClientRect();
    const h = active ? parseFloat(this.ph.style.height) || 60 : r.height;
    const top = r.top;
    const bottom = top + h;
    const originalVisible = top < window.innerHeight - 20 && bottom > this.headerBottom() + 10;
    const scrolled = window.scrollY > 260;
    const nearFooter = this.footer && isElementInViewport(this.footer);
    const show = scrolled && !originalVisible && !nearFooter;

    if (show && !active) {
      this.ph.style.height = r.height + 'px';
      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');
    } else if (!show && active) {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
      this.ph.style.height = '0px';
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
